/** 랜딩 레이아웃의 기준 해상도 — 이 크기에서 배율 1 */
export const DESIGN_W = 1920;
export const DESIGN_H = 1080;
const MAX_UP = 1.6;

/**
 * 기준 해상도보다 큰 화면에서 쓰는 확대 배율 (가로·세로 모두 커야 커짐).
 * 기준 이하에서는 항상 1 → 기존 레이아웃 그대로.
 */
export function getDesignUpScale(width = window.innerWidth, height = window.innerHeight) {
  const s = Math.min(width / DESIGN_W, height / DESIGN_H);
  return Math.min(MAX_UP, Math.max(1, s));
}
